// import Alpine from 'alpinejs';

// import _ from 'lodash';

// import QumanoLogService from '@/modules/general/g--qumano/service.js';

export const C__RecommemdedProductsNotifier = () => ({
    qumanoHasRecommendations: false,
    qumanoIsLoading: false,
    products: [],

    init() {
        this.products = JSON.parse(
            localStorage.getItem('recommended-products-from-qumano')
        );

        if (this.products && this.products.length) {
            this.qumanoHasRecommendations = true;
        }
    }
});
